import { render, staticRenderFns } from "./FindingCommentsModal.vue?vue&type=template&id=5a22d3dc&scoped=true&"
import script from "./FindingCommentsModal.vue?vue&type=script&lang=js&"
export * from "./FindingCommentsModal.vue?vue&type=script&lang=js&"
import style0 from "./FindingCommentsModal.vue?vue&type=style&index=0&id=5a22d3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22d3dc",
  null
  
)

export default component.exports